<template>
  <header class="sf-header">
    <div class="sf-header__inner">
      <div class="sf-header__persona">
        <img
          v-if="persona.imageUrl"
          :src="persona.imageUrl"
          :alt="persona.label"
          class="sf-header__avatar"
        />
        <div v-else class="sf-header__avatar sf-header__avatar--placeholder" aria-hidden="true"></div>

        <div class="sf-header__info">
          <span class="sf-header__name">Gids: {{ persona.label }}</span>
          <span v-if="persona.tagline" class="sf-header__tagline">{{ persona.tagline }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PersonaHeader',

  props: {
    persona: { type: Object, required: true },
  },
};
</script>

<style lang="scss" scoped>
.sf-header {
  background-color: #517b86;
  padding: 1.5rem 1rem;
  position: sticky;
  top: 0;
  z-index: 10;

  &__inner {
    max-width: 390px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__persona {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;

    &--placeholder {
      background-color: #b5afa5;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-family: 'Comfortaa', sans-serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #fff;
    line-height: 1.7rem;
  }

  &__tagline {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.2;
  }
}
</style>
